<template>
  <div
    :style="{
      top: `${highlightCoordinates.y - 84}px`,
      insetInlineStart: `${highlightCoordinates.x}px`
    }"
    class="highlight-tooltip flex gap-x-4 z-[100] absolute p-2 bg-black rounded-md shadow-xl"
    @click.stop=""
  >
    <div class="size-5 flex justify-center items-center">
      <faCommentDots class="w-4 fill-primary" />
    </div>
    <span class="text-white">
      {{ isSpeaking }}
    </span>
    <button @click="onSynthPlay">
      <component
        :is="synthPlaybackStatus.value == 'playing' ? faPause : faPlay"
        class="w-4 fill-white"
      />
    </button>
    <button @click="onSynthPause">
      <component :is="faPause" class="w-4 fill-white" />
    </button>
    <button @click="onSynthStop">
      <faStop class="w-4 fill-white" />
    </button>
  </div>
</template>

<script setup>
import { ref, reactive, nextTick, computed, watch } from 'vue'
import faCommentDots from '@/assets/icons/faCommentDots.svg?component'
import faPlay from '@/assets/icons/faPlay.svg?component'
import faPause from '@/assets/icons/faPause.svg?component'
import faStop from '@/assets/icons/faStop.svg?component'

const synthPlaybackStatus = ref('init')
const initialCoords = { x: null, y: null }
const highlightCoordinates = reactive({ ...initialCoords })
const highlightedText = ref()

const synth = computed(() => window?.speechSynthesis)
const isSpeaking = computed(() => window?.speechSynthesis.speaking)

function getSelectionAndSynthesize() {
  const selection = window.getSelection()
  highlightedText.value = selection.toString()?.trim()
  if (!selection || selection.rangeCount === 0 || !highlightedText.value) {
    return
  }

  const range = selection.getRangeAt(0)
  const rect = range.getBoundingClientRect()

  highlightCoordinates.x = rect.left + window.scrollX
  highlightCoordinates.y = rect.top + window.scrollY
}

document.addEventListener('mouseup', (e) => {
  if (e.target.closest('.highlight-tooltip')) {
    return
  }

  setTimeout(getSelectionAndSynthesize, 1)
})

document.addEventListener('mousedown', (e) => {
  // prevent reset of coordinates when click is inside .hightlight-tooltip
  if (e.target.closest('.highlight-tooltip')) {
    return
  }

  Object.assign(highlightCoordinates, initialCoords)
})

async function onSynthPlay() {
  nextTick()

  if (window.speechSynthesis.paused) {
    window.speechSynthesis.resume()
    return
  }

  const utterance = new SpeechSynthesisUtterance(highlightedText.value)
  window.speechSynthesis.speak(utterance)
}

function onSynthPause() {
  window.speechSynthesis.pause()
}

function onSynthStop() {
  window.speechSynthesis.cancel()
}
</script>

<script>
export default { name: 'HighlightTracker' }
</script>

<style lang="scss" scoped></style>
